module.exports = __webpack_public_path__ + "img/sn-banner3.df399dc0.png";